export const summaryRows: string[] = [
  'Volume 01 — Heat & Steam Fundamentals: Heat Transfer, Steam Properties & Plant Utilities',
  'Volume 02 — Industrial Boilers: Types, Components, Fuels & Combustion',
  'Volume 03 — Boiler Water Treatment, Controls & Safety Devices',
  'Volume 04 — Steam Distribution, Steam Traps & Condensate Recovery',
  'Volume 05 — Heat Exchangers: Types, Thermal Principles & Performance',
  'Volume 06 — Inspection, Maintenance, Cleaning & Troubleshooting',
  'Bonus 1 — Steam Tables, Heat Transfer Formulas & Unit Conversions Quick Reference',
  'Bonus 2 — Boiler Room Daily Checks, Startup & Shutdown Checklists',
  'Bonus 3 — Boiler & Heat Exchanger Troubleshooting Guide',
  'Bonus 4 — Boilers & Heat Exchangers Glossary & Abbreviations Handbook',
  'Bonus 5 — Boiler Room Safety & Lockout/Tagout Field Handbook',
  '7-day money-back guarantee',
  'Instant access',
];
